import Vue from 'vue'
import Header from './header.component.vue'
import { NO_CTRL } from './header.constants'

const headerSubscription = (component) => {
  return Vue.component('headerSubscription', {
    data () {
      const { currentRoute } = this.$router
      return {
        title: this.$t(`${currentRoute.name}`),
        hasStartCtrl: NO_CTRL !== currentRoute.name,
        toggleClass: currentRoute.name === 'product'
          ? 'preview'
          : 'product'
      }
    },

    computed: {
      hasModiface () {
        return this.$store.getters['SDK/getStatus']
      },
      displayModiface () {
        const { name } = this.$route
        return this.hasModiface && this.hasStartCtrl && name !== 'preview' && this.$store.getters['SDK/eanExists'](this.$route.params.eanupc)
      },
      displayLanguage () {
        const { name } = this.$route

        return name === 'products'
      },
      isPreviewPage () {
        const { name } = this.$route
        return name === 'preview'
      }
    },

    watch: {
      $route (to) {
        this.title = this.$t(`${to.name}`)
        this.hasStartCtrl = NO_CTRL !== to.name

        if (this.hasModiface) {
          this.toggleClass = to.name === 'product'
            ? 'preview'
            : 'product'
        }
      }
    },

    methods: {
      back () {
        return this.$router.push({ name: 'products' })
      },
      toPreview () {
        const { params } = this.$route
        this.$router.replace({ name: 'preview', params })
      },
      toggleMode () {
        const { currentRoute } = this.$router
        const path = `/${currentRoute.name === 'product'
          ? 'preview'
          : 'products'}/${currentRoute.params.eanupc}`

        return this.$router.replace({ path })
      }
    },

    render (createElement) {
      const { hasStartCtrl, hasModiface, displayModiface, displayLanguage, title, toggleClass, isPreviewPage } = this
      return createElement(component, {
        props: {
          hasStartCtrl,
          hasModiface,
          displayModiface,
          title,
          toggleClass,
          displayLanguage,
          isPreviewPage
        },
        on: {
          back: this.back,
          toPreview: this.toPreview
        }
      })
    }
  })
}

export default headerSubscription(Header)
